import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 12h12.387m0 0-5.161-5m5.161 5-5.161 5m8.258-10v10" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
